module.exports = __webpack_public_path__ + "img/aParty_121223_I.44cbee88.jpg";